<template>
  <div :class="['custom-notification', notificationType]">
    <transition name="slide-fade">
      <div v-if="show" class="notification-content">
        <div class="icon-container">
          <img v-if="notificationType == 'success'" src="../../assets/images/verify/success.png" alt="icon"
            class="notice-icon" />
          <img v-if="notificationType == 'warning'" src="../../assets/images/verify/warning.png" alt="icon"
            class="notice-icon" />
          <img v-if="notificationType == 'info'" src="../../assets/images/info.png" alt="icon" class="notice-icon" />
          <img v-if="notificationType == 'error'" src="" alt="icon" class="notice-icon" />
          <div v-if="notificationType == 'totalTable'">
            <div v-for="(sub, index) in dataTable" :key="index" class="customnot_title" style="margin-bottom: 8px">
              <p>
                {{ sub.importSetting }} {{ sub.tableName }} import ({{
                  sub.total
                }}) complete
              </p>
            </div>
            <table class="custom-table">
              <thead>
                <tr>
                  <th>{{ $t("Added") }}</th>
                  <th>{{ $t("Deleteted") }}</th>
                  <th>{{ $t("Updated") }}</th>
                  <th>{{ $t("Invalid") }}</th>
                  <th>{{ $t("Unchanged") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in processedDataTable" :key="index">
                  <td>{{ item.added }}</td>
                  <td>{{ item.deleted }}</td>
                  <td>{{ item.updated }}</td>
                  <td>{{ item.invalid }}</td>
                  <td>{{ item.unchanged }}</td>
                </tr>
              </tbody>
            </table>
            <div class="customnot_title" style="margin-top: 8px" @click="viewResultLog()">
              {{ $t("Viewresults") }}
            </div>
          </div>

          <div v-if="notificationType == 'toBeTable'">
            <div v-for="(sub, index) in dataTable" :key="index" class="customnot_title" style="margin-bottom: 8px">
              <p>
                {{ sub.importSetting }} {{ sub.tableName }} import ({{
                  sub.total
                }}) complete
              </p>
            </div>
            <table class="custom-table">
              <thead>
                <tr>
                  <th>{{ $t("ToBeAdded") }}</th>
                  <th>{{ $t("ToBeUpdated") }}</th>
                  <th>{{ $t("ToBeDeleted") }}</th>
                  <th>{{ $t("Invalid") }}</th>
                  <th>{{ $t("Unchanged") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in processedDataTable" :key="index">
                  <td>{{ item.toBeAdded }}</td>
                  <td>{{ item.toBeUpdated }}</td>
                  <td>{{ item.toBeDeleted }}</td>
                  <td>{{ item.invalid }}</td>
                  <td>{{ item.unchanged }}</td>
                </tr>
              </tbody>
            </table>
            <div class="customnot_title" style="margin-top: 8px" @click="viewResultLog()">
              {{ $t("Viewresults") }}
            </div>
          </div>
        </div>
        <div class="notice-content">
          <span>{{ message }}</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      message: '',
      notificationType: '',
      iconClass: '', // Icon class
      isTableVisible: false, // 控制表格显示
      iconMap: {
        success: 'success-icon.png', // 根据不同类型的通知指定不同的图标文件名
        warning: 'warning-icon.png',
        error: 'error-icon.png',
        info: 'info-icon.png'
      },

      dataTable: [],
      isMouseOver: false // 新增变量，用于记录鼠标是否悬停在通知上
    }
  },
  computed: {
    processedDataTable () {
      return this.dataTable.map((item) => ({
        id: item.id,
        tableName: item.tableName === null ? 0 : item.tableName,
        added: item.added === null ? 0 : item.added,
        deleted: item.deleted === null ? 0 : item.deleted,
        updated: item.updated === null ? 0 : item.updated,
        invalid: item.invalid === null ? 0 : item.invalid,
        unchanged: item.unchanged === null ? 0 : item.unchanged,
        toBeAdded: item.toBeAdded === null ? 0 : item.toBeAdded,
        toBeUpdated: item.toBeUpdated === null ? 0 : item.toBeUpdated,
        toBeDeleted: item.toBeDeleted === null ? 0 : item.toBeDeleted
      }))
    }
  },

  methods: {
    showNotification (message, type, dataTable) {
      this.message = message
      this.notificationType = type || 'info'
      this.show = true
      this.dataTable = dataTable // 将接收到的表格数据赋值给组件内的dataTable数据项

      // 添加类名触发通知从右侧出现的动画效果
      this.$nextTick(() => {
        document.querySelector('.custom-notification').classList.add('show')
      })
      setTimeout(() => {
        this.dismiss()
      }, 5000)
      let timer = setTimeout(() => {
        this.dismiss()
      }, 5000)

      // // 监听鼠标进入通知区域事件，设置isMouseOver为true，并清除定时器
      // const notificationElement = document.querySelector(
      //   ".custom-notification"
      // );
      // notificationElement.addEventListener("mouseenter", () => {
      //   this.isMouseOver = true;
      //   if (timer) {
      //     clearTimeout(timer);
      //   }
      // });

      // // 监听鼠标离开通知区域事件，设置isMouseOver为false，并重新设置定时器
      // notificationElement.addEventListener("mouseleave", () => {
      //   this.isMouseOver = false;
      //   if (!this.isMouseOver) {
      //     timer = setTimeout(() => {
      //       this.dismiss();
      //     }, 5000);
      //   }
      // });
    },
    dismiss () {
      this.show = false
      this.message = ''
      this.notificationType = ''
      this.iconClass = ''
      // 移除类名，以便下次显示时能正常触发从右侧出现的动画效果
      document.querySelector('.custom-notification').classList.remove('show')
    },

    viewResultLog () {
      this.$emit('importLog-page')
    }
  }
}
</script>

<style>
.custom-notification {
  position: fixed;
  top: 60px;
  right: -380px;
  /* 将初始位置设置在右侧屏幕外 */
  z-index: 9999;
  font-size: 18px;
  height: auto;
  transition: right 0.3s ease;
  /* 添加过渡效果，使位置变化更平滑 */
}

/* 当通知显示时，将其移动到正确的显示位置 */
.custom-notification.show {
  right: 20px;
}

.notification-content {
  padding: 10px 15px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.notice-content {
  margin-left: 5px;
  flex-grow: 1;
  margin-left: 10px;
  font-size: 16px;
}

.notice span {
  display: block;
  word-wrap: break-word;
}

.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.notice-icon {
  width: 25px;
  height: 25px;
}

.dismiss-button {
  position: absolute;
  top: 5px;
  right: 5px;
  border: none;
  background: none;
  cursor: pointer;
  color: #999;
}

.countdown-bar {
  position: absolute;
  bottom: 0px;
  left: 0;
  width: 100%;
  height: 1.5px;
  background: linear-gradient(to right,
      #adadad 0%,
      #a7a7a7 100%,
      transparent 50%,
      transparent 100%);
  animation: countdown 5s linear forwards;
}

@keyframes countdown {
  from {
    width: 0px;
  }

  to {
    width: 380px;
  }
}

.info {
  background-color: #ccffd7;
}

.success {
  background-color: #2da949;
  color: #fff;
  box-shadow: 0 0 0 1px #40ad52 inset, 0 0 0 0 transparent;
  border-radius: 5px;
}

.warning {
  background-color: #dc3545;
  color: #fff;
  box-shadow: 0 0 0 1px #e0b4b4 inset, 0 0 0 0 transparent;
  border-radius: 5px;
}

.error {
  background-color: #fff3cd;
}

.totalTable,
.toBeTable {
  background-color: #fff;
  box-shadow: 0 0 0 1px #ccc inset, 0 0 0 0 transparent;
  border-radius: 5px;
}

tr,
th {
  font-size: 12px;
}

.custom-table {
  margin: auto;
  text-align: center;
  border-collapse: collapse;
  border: 1px solid #0082b6;
}

.custom-table th,
.custom-table td {
  text-align: center;
  border: 1px solid #0082b6;
  padding: 8px;
}

.custom-table th {
  background-color: #2d8cf0;
  color: #fff;
}

.customnot_title {
  text-align: center;
  color: #0082b6;
  font-size: 16px;
  cursor: pointer;
}
</style>
